// extracted by mini-css-extract-plugin
export default {"primary":"button_primary__C58hC"};